import { NextSeo } from 'next-seo';
import PayrollPage from '_components/composed/pages/PayrollPage';

export default function Payroll() {
  return (
    <>
      <NextSeo
        title="Comprehensive Payroll Services by Incorpified - Simplify Your Payroll"
        description="Simplify your payroll with Incorpified. Our comprehensive payroll services ensure timely and accurate employee payments and compliance with regulations."
      />
      <PayrollPage />
    </>
  );
}
